import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { createSupplementalQuestion } from "~/providers/api";
import { supplementalQuestionsQueryOptionsFactory } from "~/providers/factories/supplementalQuestionsQueryOptionsFactory";

export const useCreateSupplementalQuestion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSupplementalQuestion,
    onError: () =>
      toast.error(
        "There was an issue storing the new question. Please try again later.",
      ),
    onSuccess: () => {
      queryClient
        .invalidateQueries({
          queryKey: supplementalQuestionsQueryOptionsFactory.list._def,
          exact: false,
        })
        .catch(() => {
          toast.error("Failed to refresh questions data.");
        });
    },
  });
};
